export default { 
  cartola_manutencao: false,
}